import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Eye = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4d7__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4d7__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M3.653 22.946C9.182 14.028 15.713 9 23.353 9c7.64 0 14.171 5.028 19.7 13.946L43.706 24l-.653 1.054C37.524 33.972 30.993 39 23.353 39c-7.64 0-14.171-5.028-19.7-13.946L3 24l.653-1.054ZM7.723 24c5.015 7.666 10.255 11 15.63 11s10.616-3.334 15.63-11c-5.014-7.666-10.255-11-15.63-11s-10.615 3.334-15.63 11Zm15.63-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-7 3a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#475466"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
